export default __webpack_public_path__ + "static/media/vantagem2.f2dfb5be.png";